<template>
    <div class="specialExamMgt">
        <div class="filters">
            <div class="add flexstart"></div>
            <div class="search">
                <el-date-picker v-model="timeSlot" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
                    class="condition" :picker-options="pickerDateFront" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
                <el-select v-model="subjectcode" placeholder="选择科目" clearable style="width: 150px">
                    <el-option v-for="item in subjectList" :key="item.subjectcode" :label="item.subjectname" :value="item.subjectcode"></el-option>
                </el-select>
                <el-select v-model="sectioncode" placeholder="选择板块" clearable style="width: 150px">
                    <el-option v-for="item in sectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input v-model="exampapername" placeholder="请输入试卷名称" class="condition" clearable></el-input>
                <el-input v-model="customername" placeholder="请输入用户名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                <el-table-column label="序号" width="80px" align="center" fixed>
                    <template slot-scope="scope">{{(page.page - 1) * page.pagesize + scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="subject" label="用户名称" min-width="150px" class-name="title" fixed>
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img class="img" v-lazy="scope.row.headimageurl" :alt="scope.row.customername" preview="bbOrderList">
                            <span class="text-ellipse">{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="subjectname" label="科目名称" min-width="150px" show-overflow-tooltip>
                    <template slot-scope="scope"><div class="text-ellipse">{{scope.row.subjectname}}</div></template>
                </el-table-column>
                <el-table-column prop="sectionname" label="板块名称" min-width="150px" show-overflow-tooltip>
                    <template slot-scope="scope"><div class="text-ellipse">{{scope.row.sectionname}}</div></template>
                </el-table-column>
                <el-table-column prop="exampapername" label="试卷名称" min-width="150px" show-overflow-tooltip>
                    <template slot-scope="scope"><div class="text-ellipse">{{scope.row.exampapername}}</div></template>
                </el-table-column>
                <el-table-column label="完成情况" width="120px" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope">
                        {{ scope.row.finishcount }}/{{ scope.row.quescount }}
                    </template>
                </el-table-column>
                <el-table-column prop="rightrate" label="正确率" width="100px" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="begintime" label="开始时间" width="150px" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="submittime" label="提交时间" width="150px" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column label="操作" min-width="80px" label-class-name="tr" fixed="right">
                    <template slot-scope="scope">
                        <div class="tr">
                            <span class="separator-btn">
                                <el-button @click.stop="handleView(scope.row)" type="text" size="small">查看</el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                           :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbankexaminfo} from 'api/questionApi'
import SpecialBank from '@/common/js/specialBank.json'
export default {
    name: 'specialExamMgt',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            timeSlot: null,
            subjectList: [],
            sectionList: [
                {label: '每日一练', value: '0100'},
                {label: '章节练习', value: '0101'},
                {label: '历年真题', value: '0102'},
                {label: '模拟试题', value: '0103'}
            ],
            exampapername: '', // 试题名称
            customername: '', // 用户名称
            sectioncode: '', // 板块类型
            subjectcode: '', // 科目名称
            param: {
                exampapername: '',
                begintime: '',
                endtime: '',
                customername: '',
                sectioncode: '',
                subjectcode: '',
                examcode: this.$route.query.examcode ? this.$route.query.examcode : ''
            },
            pickerDateFront: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                onPick({ maxDate, minDate }) {
                    if (maxDate) {
                        if (maxDate - minDate > 30 * 24 * 60 * 60 * 1000) {
                            this.$message.error('时长不能超过30天，请重新选择')
                        }
                    }
                }
            },
            init: false
        }
    },
    created() {
        if (this.$route.query.examcode) {
            this.subjectList = JSON.parse(JSON.stringify(SpecialBank[this.$route.query.examcode].children))
        }
    },
    mounted() {
    },
    methods: {
        initData() {
            if (!this.init) this._getList()
        },
        handleView(row) {
            this.$router.push({name: 'MarkingDetails', query: {id: row.examid}})
        },
        handleQuery() {
            if (this.timeSlot) {
                let beginDate = new Date(this.timeSlot[0])
                let endDate = new Date(this.timeSlot[1])
                if (endDate- beginDate > 30 * 24 * 60 * 60 * 1000) {
                    this.$message.error('时长不能超过30天，请重新选择')
                    return false
                }
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.param.sectioncode = this.sectioncode
            this.param.subjectcode = this.subjectcode
            this.page.page = 1
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getQuestionbankexaminfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialExamMgt {
    .el-select {
        .el-input {
            width: 150px !important;
            input {
                width: 150px !important;
            }
        }
    }
}
</style>
